<template>
  <el-container>
    <el-main style="width: 70%">
      <div
        style="
          margin-bottom: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item
            ><span class="item_font">自定义话术</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>

      <div>
        <el-button
          type="text"
          size="mini"
          style="margin-right: 12px; color: orangered"
          >请先选择科室</el-button
        >
        <el-select
          v-model="department"
          size="mini"
          placeholder="请选择科室"
          @change="changeDep"
          style="margin-right: 12px"
        >
          <el-option
            v-for="(item, index) in departmentList"
            :key="index"
            :label="item.name"
            :value="item.depType"
          ></el-option>
        </el-select>

        <el-input
          v-model="searchContent"
          :disabled="!department"
          @input="searchTopicList"
          placeholder="请输入长度至少为2的搜索内容"
          size="mini"
          style="width: 200px"
        ></el-input>
        <el-button
          type="primary"
          size="mini"
          style="margin-left: 12px"
          @click="updateAll"
          >全量同步</el-button
        >
        <el-button
          type="danger"
          size="mini"
          @click="deleteAllOrNode(0)"
          style="margin-left: 12px"
          >全量删除</el-button
        >
        <el-button
          type="primary"
          size="mini"
          style="margin-left: 12px"
          @click="addKnowledge"
          >新增元知识点</el-button
        >
        <el-button
          type="danger"
          size="mini"
          @click="importAction"
          style="margin-left: 12px"
          >导入</el-button
        >

        <el-button
          type="primary"
          size="mini"
          @click="exportAction"
          style="margin-left: 12px"
          >导出</el-button
        >
      </div>

      <!--话术列表-->
      <div class="talkListBox" v-loading="diaLoading">
        <dl v-for="(item, index) in talkTopicList" :key="index">
          <dt @click="showList(item, index)">
            <i
              :class="
                onIndex == index ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
              style="color: #333"
            ></i>
            {{ item.name }}
            <el-button
              type="danger"
              size="mini"
              style="float: right; margin-left: 10px"
              @click.stop="deleteAllOrNode(1, item)"
              >删除</el-button
            >
            
            <el-button
              size="mini"
              type="primary"
              style="float: right"
              @click.stop="updateList(item)"
              >更新</el-button
            >
            <el-tooltip :content="item.auth?'启用':'禁用'" placement="left">
            
              <el-switch
                v-model="item.auth"
                active-color="#5A9CF8"
                style="float: right; margin-right: 10px; margin-top: 5px"
                inactive-color="#D0CECE"
                :active-value="1"
                @click.native.stop="updateAuth(item)"
                :inactive-value="0"
              >
              </el-switch>
            </el-tooltip>
            <!-- <el-button
              size="mini"
              type="primary"
              style="float: right; margin-right: 10px"
              @click.stop="updateAuth(item)"
              >{{ item.auth == 1 ? "禁用" : "启用" }}</el-button
            > -->
          </dt>
          <div
            class="contentItemBox"
            v-if="onIndex == index"
            v-loading="diaLoading"
          >
            <dd
              v-for="(items, indx) in item.customUtterVoList"
              :key="indx"
              :class="onIndexs == indx ? 'active' : ''"
              @click="showClass(indx)"
              style="display: flex; flex-direction: nowrap"
            >
              <!-- @contextmenu.prevent="showDet(item, items, indx, index)" -->
              <div>
                <span class="title">{{ items.bsId }}</span>
                <span
                  v-show="items.status == 1 && items.customUtters != null"
                  class="log"
                  >[已改话术]</span
                >
              </div>

              <span class="contentItem">
                {{
                  items.status == 1 && items.customUtters != null
                    ? items.customUtters[0].content
                    : items.content
                }}
              </span>
              <el-button
                type="primary"
                size="mini"
                style="float: right; margin-left: 10px"
                @click.stop="showDet(item, items, indx, index)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                style="float: right; margin-left: 10px"
                @click.stop="deleteUtter(item, items)"
                >删除</el-button
              >
            </dd>
          </div>
        </dl>
      </div>
      <el-dialog
        :title="addOrEdit == 'add' ? '新增元知识点' : '更新话术'"
        :visible.sync="addQuery"
        custom-class="dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="60%"
        center
        v-loading="diaLoading"
        @close="closeTalkDialog"
      >
        <el-form label-width="90px">
          <el-form-item label="" style="text-align: right; margin-bottom: 10px">
            <el-select
              v-model="changeItem"
              placeholder="选择插入变量"
              size="mini"
              clearable
              @change="choChangeItem"
            >
              <el-option
                v-for="item in changeItemList"
                :key="item.varName"
                :label="item.name"
                :value="item.varName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div
            v-if="addOrEdit == 'add'"
            class="custom_box"
            style="
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: flex-start;
              margin-top: 20px;
            "
          >
            <span style="white-space: nowrap; width: 10%; margin-top: 5px"
              >知识点名称:</span
            >
            <div
              class="talk_list"
              style="
                width: 90%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
              "
            >
              <el-input v-model="knowledgeName" size="mini"></el-input>
            </div>
          </div>

          <div
            v-if="showDefaultTalk && addOrEdit == 'edit'"
            class="default_box"
            style="
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: flex-start;
            "
          >
            <span style="white-space: nowrap; width: 10%; margin-top: 5px"
              >默认话术:</span
            >
            <div
              class="talk_list"
              style="
                width: 90%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in talkList"
                :key="index"
                style="
                  margin-left: 10px;
                  margin-top: 5px;
                  display: flex;
                  justify-content: space-between;
                  align-items: flex-start;
                "
              >
                <span>{{ index + 1 }}.{{ item.content }}</span>
                <a
                  style="
                    margin-right: 12px;
                    margin-left: 12px;
                    white-space: nowrap;
                    color: #0048ab;
                  "
                  @click="importTalk(item)"
                  >引用</a
                >
              </div>
            </div>
          </div>

          <div
            class="custom_box"
            style="
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: flex-start;
              margin-top: 20px;
            "
          >
            <span style="white-space: nowrap; width: 10%; margin-top: 5px"
              >自定义话术:</span
            >
            <div
              class="talk_list"
              style="
                width: 90%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
              "
            >
              <el-table
                class="talk_cuslist_table"
                v-if="addOrEdit === 'edit'"
                :data="customTalkList"
                style="width: 100%"
                :header-cell-style="headerStyleFn"
              >
                <el-table-column label="时间" width="390">
                  <template slot-scope="scope">
                    <el-time-picker
                      v-model="scope.row.startTime"
                      :picker-options="{
                        selectableRange: '00:00:00 - 23:59:59',
                      }"
                      placeholder="任意时间点"
                      format="HH:mm:ss"
                      value-format="HH:mm:ss"
                    >
                    </el-time-picker>
                    <el-time-picker
                      v-model="scope.row.endTime"
                      :picker-options="{
                        selectableRange: '00:00:00 - 23:59:59',
                      }"
                      placeholder="任意时间点"
                      format="HH:mm:ss"
                      value-format="HH:mm:ss"
                    >
                    </el-time-picker>
                  </template>
                </el-table-column>
                <el-table-column label="话术内容" width="400">
                  <template slot-scope="scope">
                    <div style="width: 100%">
                      <div
                        class="speakWayCont"
                        v-for="(item, index) in scope.row.contentsText"
                        :key="index"
                      >
                        <el-input
                          v-model="item.text"
                          type="textarea"
                          :rows="3"
                          size="mini"
                          placeholder="请输入话术内容"
                        />
                        <el-popconfirm
                          confirm-button-text="确认"
                          cancel-button-text="取消"
                          icon="el-icon-info"
                          title="这段话术确定删除吗？"
                          @confirm="deleteScript(index, scope.row)"
                        >
                          <el-button size="mini" type="danger" slot="reference"
                            >删除话术</el-button
                          >
                        </el-popconfirm>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="success"
                      @click="addScript(scope.$index, scope.row)"
                      style="margin-right: 20px"
                      >新增话术</el-button
                    >
                    <el-popconfirm
                      confirm-button-text="确认"
                      cancel-button-text="取消"
                      icon="el-icon-info"
                      title="这段话术确定删除吗？"
                      @confirm="deleteRow(scope.$index, scope.row)"
                    >
                      <el-button size="mini" type="danger" slot="reference"
                        >删除话术</el-button
                      >
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else>
                <div
                  v-for="(item, index) in yuanArr"
                  :key="index"
                  class="talk_list_yuan"
                >
                  <el-input
                    :id="'textInput_' + index"
                    v-model="item.text"
                    size="mini"
                  ></el-input>
                  <a
                    style="
                      margin-right: 12px;
                      white-space: nowrap;
                      color: #0048ab;
                      margin-left: 12px;
                    "
                    @click="deleteCustomTalk(index)"
                    >删除</a
                  >
                </div>
              </div>
            </div>
          </div>

          <el-form-item
            label-width="0"
            style="text-align: center; margin-top: 12px"
          >
            <el-button @click="addCustomTalk" size="mini" type="primary"
              >添加</el-button
            >
          </el-form-item>

          <el-form-item
            label-width="0"
            style="text-align: center; margin-top: 12px"
          >
            <el-button @click="addQuery = false" size="mini">取 消</el-button>
            <el-button
              v-if="addOrEdit == 'edit'"
              type="primary"
              size="mini"
              @click="updateCustomUtter"
              >确 定</el-button
            >
            <el-button
              v-if="addOrEdit == 'add'"
              type="primary"
              size="mini"
              @click="addMetaKnowledgeNode"
              >添 加</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>

      <div v-show="showImport" class="item_font">
        <el-dialog
          title="上传文件到服务器"
          :visible.sync="showImport"
          width="50%"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            ref="upload"
            :on-success="uploadSuccess"
            :data="importType"
            :headers="myHeaders"
            :file-list="fileList"
            :before-upload="beforeUpload"
            accept=".xls,.xlsx"
            style="width: 60%; margin: 0 auto; margin-bottom: 3.125rem"
          >
            <el-button size="small" type="primary" class="item_font"
              >点击上传文件</el-button
            >
            <div slot="tip" class="el-upload__tip item_font">
              支持上传xls和xlsx格式的文件
            </div>
          </el-upload>
        </el-dialog>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { MessageBox } from "element-ui";
export default {
  data() {
    return {
      talkTopicList: [],
      addQuery: false,
      talkCont: "",
      talkUpdateCont: "",
      talkId: "",
      onIndex: null,
      onIndexs: null,
      diaLoading: true,
      changeItem: "",
      changeItemList: [],
      talkList: [],
      topIndex: "",
      secIndex: "",
      topId: "",
      secName: "",
      departmentList: [],
      department: 1,
      searchContent: null,
      showDefaultTalk: false,
      customTalkList: [],
      yuanArr: [],
      titleId: null,
      addOrEdit: "add",
      knowledgeName: "",

      //导入功能
      showImport: false,
      uploadUrl:
        JSON.parse(localStorage.getItem("siteObj")).webUrl +
        "/manager/devops/syncUtter/customUtterExcelImport",
      myHeaders: {
        Authorization: localStorage.getItem("token"),
      },
    };
  },

  created() {},

  mounted() {
    this.getItemList();
    // this.getTalksList()
    this.getDepartmentList();
    // this.getUtterTopicList()
    this.$nextTick(() => {
      this.getUtterTopicList();
    });
  },

  methods: {

    importAction() {
      this.showImport = true;
    },

    beforeUpload(file) {
      console.log("beforeUpload", file);
      const isJPG = file.type === "excel" || "xls" || "xlsx";
      const isLt10M = file.size < 1024 * 1024 * 10;
      if (!isJPG) {
        this.$message.error("只能上传xls格式文件!");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传的文件大小不能超过 10MB!");
        return false;
      }
    },

    uploadSuccess(res, file) {
      console.log("quick uploadSuccess res = ", res, file);
      if (res.resultCode === "10000") {
        const tipMsg = "导入文件成功!";
        this.$message.success(tipMsg);
        this.showImport = false;
        this.$refs.upload.clearFiles();
        this.getItemList();
        this.getDepartmentList();
        this.$nextTick(() => {
          this.getUtterTopicList();
        });
      } else {
        this.$refs.upload.clearFiles();
        this.$message.error(res.desc);
      }
    },

    async exportAction() {
      var api = "/manager/devops/syncUtter/customUtterExportToExcel/"+ this.department;
      const response = await this.util.postRequest({
        url: api,
        method: "GET",
        data: {},
        responseType: "arraybuffer",
      });
      console.log(response);
      let blob = new Blob([response], { type: "application/vnd.ms-excel" });
      let fileName = this.util.getLocalAccount().realName + "自定义话术" + ".xls";
      this.downFile(blob, fileName);
    },
    downFile(blob, fileName) {
      if (this.$nodeFs) {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        console.log("electron 环境", fileName);
        reader.addEventListener("loadend", () => {
          const filePath = reader.result;
          const ipc = this.$electron.ipcRenderer;
          ipc.send("downLoad", {
            filePath,
            fileName,
          });
          
          console.log("electron loadend", filePath);
        });
      } else {
        console.log("非electron环境", fileName);
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      }
    },

    closeTalkDialog() {
      console.log("speechCraft.vue closeTalkDialog");
      this.knowledgeName = "";
      this.customTalkList = [];
      this.yuanArr = [];
    },
    headerStyleFn() {
      return "color:#000;text-align:center";
    },
    addScript(index, obj) {
      this.$set(obj.contentsText, obj.contentsText.length, { text: "" });

      console.log("speechCraft.vue addScript index obj:", index, obj);
    },
    deleteScript(index, obj) {
      // const _text = text.trim();
      // if (obj.contentsText.length ) {
      // }
      // console.log(_text.length);
      // if (text.l) {
      // }
      this.$delete(obj.contentsText, index);

      // obj.contentsText.splice(0, index);
      console.log("speechCraft.vue deleteScript index obj:", index, obj);
    },
    deleteRow(index, obj) {
      this.$delete(this.customTalkList, index);
      console.log("speechCraft.vue deleteRow index obj:", index, obj);
    },
    //获取变量
    async getItemList() {
      var api = "/manager/devops/bisvariable/getbisvariable";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      console.log("*****querySelect *****", response);
      if (response.resultCode == 10000) {
        this.changeItemList = response.data;
      }
    },

    // 获取科室列表
    async getDepartmentList() {
      var api = "/manager/devops/syncUtter/getDepType";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      console.log("*****querySelect getDepType*****", response);
      this.departmentList = response.data;
      if (this.departmentList.length > 0) {
        this.department = this.departmentList[0].depType;
        this.changeDep();
      }
    },

    //选择科室
    changeDep(val) {
      console.log("changeDep", val);
      this.getUtterTopicList();
      this.onIndex = null;
      this.onIndexs = null;
    },

    //获取话术topic列表
    async getUtterTopicList() {
      var api = "/manager/devops/syncUtter/getUtterTopicList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          depType: this.department,
        },
      });
      console.log("*****querySelect getUtterTopicList*****", response);
      if (response.resultCode == 10000) {
        this.diaLoading = false;
        this.talkTopicList = response.data;
        console.log("this.talkTopicList", this.talkTopicList);
        if (this.talkTopicList == 0) {
          this.$message.success("该科室暂无数据，请选择其他科室");
        }
      } else {
        this.diaLoading = false;
        this.$message.error(response.desc);
      }
    },

    showList(item, index) {
      if (this.onIndex == index) {
        this.onIndex = null;
      } else {
        this.onIndex = index;
        if (this.talkTopicList[this.onIndex]["customUtterVoList"].length == 0) {
          this.diaLoading = true;
          this.getUtters(item);
        }
      }
    },

    async getUtters(item) {
      var api = "/manager/devops/syncUtter/getUtters";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          topicId: item.id,
        },
      });
      console.log("*****querySelect getUtters*****", response);
      if (response.resultCode == 10000) {
        this.talkTopicList[this.onIndex]["customUtterVoList"] = response.data;
        this.diaLoading = false;
        console.log("this.talkTopicList", this.talkTopicList);
      } else {
        this.diaLoading = false;
        this.$message.error(response.desc);
      }
    },

    //查看详情
    showDet(item, items, index, topIndex) {
      this.topIndex = topIndex;
      this.secIndex = index;
      this.topId = item.id;
      this.secName = items.titleName;
      this.titleId = items.titleId;
      console.log("items.topicId, items.titleId", items.topicId, items.titleId);
      this.diaLoading = true;
      if (items.status == 0) {
        this.getUtterByTopicAndTitle(items.topicId, items.titleId);
        this.customTalkList = [];
        this.showDefaultTalk = true;
      } else {
        this.getUtterByTopicAndTitle(items.topicId, items.titleId);
        this.getCustomUtterList(items.topicId, items.titleId);
        this.showDefaultTalk = true;
      }
      // this.talkList = item.talkLibraryList;
      this.changeItem = "";
      this.addQuery = true;
      this.addOrEdit = "edit";
    },

    // 查询默认话术
    async getUtterByTopicAndTitle(topicId, titleId) {
      var api = "/manager/devops/syncUtter/getUtterByTopicAndTitle";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          topicId: topicId,
          titleId: titleId,
        },
      });
      console.log("*****querySelect getUtterByTopicAndTitle*****", response);
      if (response.resultCode == 10000) {
        this.talkList = response.data;
        this.diaLoading = false;
      } else {
        this.diaLoading = false;
        this.$message.error(response.desc);
      }
    },

    // 查询自定义话术
    async getCustomUtterList(topicId, titleId) {
      var api = "/manager/devops/syncUtter/getNewCustomUtterList";
      // manager/devops/syncUtter/getNewCustomUtterList
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          topicId: topicId,
          titleId: titleId,
        },
      });

      if (response.resultCode == 10000) {
        this.diaLoading = false;
        this.customTalkList = response.data;
        this.customTalkList.forEach((item) => {
          this.$set(item, "contentsText", []);
          item.contents.forEach((_item) => {
            item.contentsText.push({ text: _item });
          });
        });
        console.log(
          "*****querySelect getCustomUtterList*****",
          this.customTalkList
        );
        // this.customTalkList = [];
        // const grounMap = new Map();
        // response.data.forEach((item) => {
        //   if (!item.groupKey) {
        //     item.groupKey = "0";
        //   }
        //   if (grounMap.has(item.groupKey)) {
        //     const arr = grounMap.get(item.groupKey);
        //     arr.push(item);
        //     grounMap.set(item.groupKey, arr);
        //   } else {
        //     grounMap.set(item.groupKey, [item]);
        //   }

        // if (item.startTime === null) {
        //   item.startTime = "";
        // }
        // if (item.endTime === null) {
        //   item.endTime = "";
        // }
        // });
      } else {
        this.diaLoading = false;
        this.$message.error(response.desc);
      }
    },

    // 删除话术
    async deleteUtter(p_item, c_items) {
      console.log("speechCraft.vue deleteUtter:", p_item, c_items);
      MessageBox.alert("是否确认删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showCancelButton: true,
      })
        .then(async () => {
          const { topicId, titleId, bsId, customUtters, departmentType } =
            c_items;
          let groupKeys = new Set([]);
          if (customUtters && customUtters.length > 0) {
            customUtters.forEach((item) => {
              groupKeys.add(item.groupKey);
            });
          }
          const api = "/manager/devops/syncUtter/deleteUtter";
          const res = await this.util.postRequest({
            url: api,
            method: "POST",
            data: {
              topicId,
              titleId,
              utterId: bsId,
              depType: departmentType,
              groupKeys: [...groupKeys],
            },
          });

          if (res.resultCode != 10000) {
            this.$message.error(res.desc);
          } else {
            this.$message.success("删除成功!");
            this.getUtters(p_item);
          }
        })
        .catch(() => {
          this.$message.info("取消删除!");
        });
    },

    // 引用默认话术
    importTalk(item) {
      console.log("importTalk", item);
      const obj = JSON.parse(JSON.stringify(item));
      obj.contentsText = [
        {
          text: item.content,
        },
      ];
      this.$set(this.customTalkList, this.customTalkList.length, obj);

      // this.customTalkList.push(JSON.parse(JSON.stringify(item)));
    },

    // 增加自定义话术
    addCustomTalk() {
      const text = this.addOrEdit;
      if (text === "edit") {
        this.$set(this.customTalkList, this.customTalkList.length, {
          contentsText: [
            {
              text: "",
            },
          ],
        });
        return;
      }
      if (text === "add") {
        this.yuanArr.push({ text: "" });
        return;
      }
    },
    //选择变量
    choChangeItem(val) {
      if (this.addOrEdit === "add") {
        this.yuanArr.forEach((item) => {
          item.text += val;
        });
        return;
      }

      if (this.addOrEdit === "edit") {
        this.customTalkList.forEach((item) => {
          item.contentsText.forEach((_item) => {
            _item.text += val;
          });
        });
        return;
      }
    },

    // 删除自定义话术
    deleteCustomTalk(index) {
      MessageBox.alert("是否确认删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showCancelButton: true,
      })
        .then(() => {
          this.yuanArr.splice(index, 1);
          this.$message.success("删除成功!");
        })
        .catch(() => {
          this.$message.info("取消删除!");
        });
    },

    async updateCustomUtter() {
      let sendObj = {
        customutterList: [],
        titleId: this.titleId,
      };
      for (let i = 0, len = this.customTalkList.length; i < len; i++) {
        const item = this.customTalkList[i];
        if (!item.startTime || !item.endTime) {
          this.$message.error(
            "开始时间或者结束时间不能为空，请确认后再进行保存！"
          );
          return;
        }
        for (const _item of item.contentsText) {
          const text = _item.text.trim();
          if (text.length === 0) {
            this.$message.error("自定义话术不能为空，请确认后再进行保存");
            return;
          } else {
            sendObj.customutterList.push({
              startTime: item.startTime || null,
              endTime: item.endTime || null,
              content: text,
              groupKey: item.startTime ? i + 1 : null,
            });
          }
        }
      }
      console.log("*****queryUpdate updateCustomUtter sendObj*****", sendObj);
      const api = "/manager/devops/syncUtter/newUpdateCustomUtter";
      const res = await this.util.postRequest({
        url: api,
        method: "POST",
        data: sendObj,
      });
      if (res.resultCode == 10000) {
        this.$message.success("更新成功!");
        this.addQuery = false;
        this.diaLoading = true;
        this.onIndex = null;
        this.getUtterTopicList();
      } else {
        this.$message.error(res.desc);
      }

      // let updateTalkList = [];
      // for (let i = 0, len = this.customTalkList.length; i < len; i++) {
      //   updateTalkList.push(this.customTalkList[i].content.replace(/\s+/g, ""));
      // }
      // if (updateTalkList.indexOf("") == -1) {
      //   var api = "/manager/devops/syncUtter/updateCustomUtter";
      //   const response = await this.util.postRequest({
      //     url: api,
      //     method: "POST",
      //     data: {
      //       titleId: this.titleId,
      //       utterList: updateTalkList,
      //     },
      //   });
      //   console.log("*****queryUpdate updateCustomUtter*****", response);
      //   if (response.resultCode == 10000) {
      //     this.$message.success("更新成功!");
      //     this.addQuery = false;
      //     this.diaLoading = true;
      //     this.onIndex = null;
      //     this.getUtterTopicList();
      //   } else {
      //     this.$message.error(response.desc);
      //   }
      // } else {
      //   this.$message.error("自定义话术不能为空，请确认后再进行保存");
      // }
    },

    // 模糊搜索
    searchTopicList(val) {
      console.log("searchTopicList val", val);
      if (val.length >= 2) {
        this.getFuzzyMatchingUtters();
      } else if (val == "") {
        this.getUtterTopicList();
      }
    },
    // 模糊查询
    async getFuzzyMatchingUtters() {
      var api = "/manager/devops/syncUtter/getFuzzyMatchingUtters";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          departmentType: this.department,
          content: this.searchContent,
        },
      });
      console.log("*****querySelect getFuzzyMatchingUtters*****", response);
      this.talkTopicList = response.data;
    },
    clear(index) {
      this.customTalkList[index].content = "";
    },
    showClass(indx) {
      this.onIndexs = indx;
    },
    // 单点更新话术
    async updateList(item) {
      this.diaLoading = true;
      var api = "/manager/devops/syncUtter/syncUtter";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          depType: item.depType,
          knId: item.id,
          topic: item.name,
        },
      });
      console.log("*****querySelect updateList*****", response);
      if (response.resultCode == "10000") {
        this.$message.success("同步完成");
        if (this.onIndex != null) {
          this.getUtters(item);
        } else {
          this.diaLoading = false;
        }
      } else {
        this.$message.error(response.desc);
        this.diaLoading = false;
      }
    },

    // 全量删除话术
    deleteAllOrNode(flag, item) {
      let cont = "此操作将删除所有节点话术";
      let topicId = null;
      if (flag === 1) {
        cont = "此操作将删除“" + item.name + "”节点";
        topicId = item.id;
        console.log(item);
      }
      this.$confirm(cont, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const api = "/manager/devops/syncUtter/deleteBatchUtter";
          if (flag !== 1) {
            this.diaLoading = true;
          }

          const res = await this.util.postRequest({
            url: api,
            method: "POST",
            data: {
              topicId: topicId,
              depType: this.department,
            },
          });
          if (res.resultCode == "10000") {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getUtterTopicList();
          } else {
            this.$message.error(res.desc);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 全量更新话术
    async updateAll() {
      this.diaLoading = true;
      var api = "/manager/devops/syncUtter/syncAllUtter/" + this.department;
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      console.log("*****querySelect updateAll*****", response);
      if (response.resultCode == "10000") {
        this.onIndex = null;
        this.onIndexs = null;
        this.$message.success("同步完成");
        this.diaLoading = false;
        this.getUtterTopicList();
      } else {
        this.$message.error(response.desc);
        this.diaLoading = false;
      }
    },
    // 更新自定义权限
    async updateAuth(item) {
      var api = "/manager/devops/syncUtter/updateAuth";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          auth: item.auth,
          id: item.id,
        },
      });
      console.log("*****querySelect updateAuth*****", response);
      if (response.resultCode == "10000") {
        this.onIndex = null;
        this.onIndexs = null;
        this.$message.success("设置完成");
        this.getUtterTopicList();
      } else {
        this.$message.error(response.desc);
      }
    },
    // 新增元知识节点
    addKnowledge() {
      this.addQuery = true;
      this.addOrEdit = "add";
    },
    // 确定新增元知识节点
    async addMetaKnowledgeNode() {
      let contents = [];
      for (const item of this.yuanArr) {
        const _item = item.text.trim();
        if (_item.length === 0) {
          this.$message.error("自定义话术不能为空，请确认后再进行保存");
          return;
        } else {
          contents.push(_item);
        }
      }

      var api = "/manager/devops/syncUtter/addMetaKnowledgeNode";
      const res = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          depType: this.department,
          contents,
          metaKnowledgeNode: this.knowledgeName,
        },
      });
      console.log("*****queryUpdate addMetaKnowledgeNode*****", res);
      if (res.resultCode == 10000) {
        this.$message.success("新增元知识节点成功!");
        this.addQuery = false;
        this.diaLoading = true;
        this.onIndex = null;
        this.getUtterTopicList();
      } else {
        this.$message.error(res.desc);
      }
    },
  },
};
</script>

<style scoped="scoped">
.custom_div {
  margin-bottom: 0.9375rem;
}

.custom_div > span {
  font-size: 0.875rem;
  color: #444444;
}

.talkListBox {
  width: 100%;
  overflow: hidden;
  margin-top: 12px;
}

.talkListBox dl {
  overflow: hidden;
  margin-bottom: 10px;
}

.talkListBox dl dt {
  width: 100%;
  height: 30px;
  background: #eee;
  padding: 0 20px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 30px;
  font-weight: bold;
  color: darkgreen;
}

.talkListBox dl dd.active {
  background: #f5f5f5;
}

.talkListBox dl dd {
  padding: 5px 20px;
  overflow: hidden;
  font-size: 13px;
  line-height: 25px;
  font-weight: normal;
  border-bottom: 1px #ddd dotted;
}

.talkListBox dl dd .title {
  color: #5a9cf8;
  font-weight: normal;
}

.talkListBox dl dd .log {
  /* color: blue; */
  color: #ef6363;
  font-size: 16px;
  font-weight: 600;
  margin-left: 6px;
}

.talkListBox dl .contentItemBox {
  max-height: 400px;
  overflow-y: auto;
  cursor: default;
}
/* .talkListBox dl .contentItemBox::-webkit-scrollbar {
  height: 20px !important;
} */

.talkListBox dl .contentItemBox dd .contentItem {
  white-space: nowrap;
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-left: 6px;
}
</style>
<style scoped lang="scss">
.talk_list_yuan {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:not(:first-child) {
    margin-top: 10px;
  }
}
/deep/.talk_cuslist_table {
  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-date-editor {
    width: 180px;

    &:first-child {
      margin-right: 12px;
    }
    .el-input__inner {
      height: 30px;
    }
    .el-input__icon {
      line-height: 30px !important;
    }
  }

  .speakWayCont {
    display: flex;
    width: 100%;
    align-items: center;
    &:not(:first-child) {
      margin-top: 20px;
    }
    .el-button {
      margin-left: 20px;
    }
  }
}
</style>
